export enum PaymentMethod {
  Credit = "Credit",
  Debit = "Debit",
  Pix = "Pix",
  Dinheiro = "Dinheiro",
  Cash = "Cash",
}

export enum MethodId {
  Credit = "credit",
  Debit = "debit",
  Pix = "pix",
  Dinheiro = "dinheiro",
}

export enum ProviderState {
  Enabled = "Enabled",
}

export enum ProviderType {
  LocalPayment = "LocalPayment",
}

export enum ProviderCode {
  LocalPayment = "LocalPayment",
}

export enum CardBrand {
  Mastercard = "Mastercard",
  Visa = "Visa",
  Hipercard = "Hipercard",
  Elo = "Elo",
  Amex = "Amex",
}
